import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const MessageContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 306px;
  background-color: var(--background-primary);
  ::-webkit-scrollbar {
    display: none;
  }
  ${mobile_xl(css`
    max-width: 100%;
    background-color: var(--background-secondary);
    height: 100dvh;
    overflow: auto;
  `)}
`;

const MessageHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 14px 14px 14px 17px;
  border-bottom: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
  position: sticky;
  top: 0;
  ${mobile_xl(css`
    padding: 9px 20px 9px 12px;
    background-color: var(--background-secondary);
    gap: 24px;
    border-bottom: none;
  `)}
`;

const LeftHeader = styled.div`
  ${Typography.heading_md}
  color: var(--text-primary);
  ${mobile_xl(css`
    ${Typography.heading_lg}
  `)}
`;
const RightHeader = styled.div<{ disabled?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
    `}
  .plusicon {
    fill: var(--text-secondary);
  }
  :hover {
    background-color: var(--neutral-secondary);
    border-radius: 4px;
    path {
      fill: var(--text-primary);
    }
  }
  ${mobile_xl(css`
    width: 38px;
    height: 38px;
    .plusicon {
      padding: 9px;
      width: 20px;
      height: 20px;
    }
    :hover {
      background-color: transparent;
      .plusicon {
        path {
          fill: var(--text-secondary);
        }
      }
    }
  `)}
`;
const MessageData = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 2px;
  ${mobile_xl(css`
    padding: 8px 16px 16px;
    gap: 0;
    background-color: var(--background-secondary);
  `)};
`;

const Box = styled.div<{ isActive: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 5px;
  border-radius: 8px;
  :hover {
    background-color: var(--neutral-secondary);
    cursor: pointer;
  }
  ${(props: { isActive: boolean }) =>
    props.isActive &&
    css`
      background-color: var(--background-muted);
      :hover {
        background-color: var(--background-muted);
      }
      ${mobile_xl(css`
        background-color: unset;
      `)}
    `}
  ${mobile_xl(css`
    padding: 9px 4px;
    background-color: unset;
    :hover {
      background-color: var(--neutral-secondary);
    }
  `)}
`;
const Icon = styled.div`
  display: flex;
  .teamcampicon {
    rect {
      fill: var(--background-tertiary);
      stroke: var(--border-primary);
    }
    path {
      fill: var(--text-primary);
    }
  }
`;
const MessageDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
`;
const Name = styled.div<{ hasUnreadMessages?: boolean }>`
  ${Typography.body_md}
  color: var(--text-primary);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  ${(props: { hasUnreadMessages?: boolean }) =>
    props.hasUnreadMessages &&
    css`
      ${Typography.body_md_semibold}
    `}
  ${mobile_xl(css`
    line-height: 20px;
  `)}
`;

const NewChat = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 5px;
  background-color: var(--background-muted);
  border-radius: 8px;
  .chaticon {
    circle {
      fill: var(--background-tertiary);
    }
    fill: var(--text-secondary);
  }
  ${mobile_xl(css`
    padding: 14px 16px;
  `)}
`;

const RightChat = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 11px;
`;

const ResponsiveBarIcon = styled.div`
  display: none;
  ${mobile_xl(css`
    display: flex;
  `)}
`;

const IconWithTitle = styled.div`
  display: flex;
  gap: 24px;
  ${mobile_xl(css`
    gap: 12px;
    align-items: center;
  `)}
`;
const EmptyBox = styled.div`
  display: none;
  ${mobile_xl(css`
    display: block;
  `)}
`;
const SectionHeading = styled.p`
  ${Typography.body_md_medium};
  margin: 18px 5px 6px;
  color: var(--text-secondary);
  :first-child {
    margin-top: 0;
  }
  ${mobile_xl(css`
    margin: 24px 0 4px;
    padding: 0 4px;
    :first-child {
      margin-top: 0;
    }
  `)}
`;

const UnpinChat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  ${mobile_xl(css`
    gap: 4px;
    margin-bottom: 60px;
  `)}
`;

export {
  MessageHeader,
  MessageContent,
  LeftHeader,
  RightHeader,
  MessageData,
  Box,
  MessageDetail,
  Name,
  Icon,
  NewChat,
  RightChat,
  ResponsiveBarIcon,
  IconWithTitle,
  EmptyBox,
  SectionHeading,
  UnpinChat
};
